import { Pipe, PipeTransform } from '@angular/core';
import { LocalStorage } from '../local-storage.class';
import { FileStorage, Settings } from '../settings.class';
import { User } from '../user.interface';

@Pipe({
    name: 'profilePictureUrl',
    standalone: false,
})
export class ProfilePictureUrlPipe implements PipeTransform {
    transform(user: User): string {
        return user?.profile_picture
            ? Settings.RESOURCES_ENDPOINT +
                  FileStorage.ProfilePictures +
                  '/' +
                  user.profile_picture +
                  '?access_token=' +
                  LocalStorage.getUserToken()
            : null;
    }
}
